export const QUICK_MENU_UPLOAD_DIRECTORY =
  process.env.REACT_APP_ENV === 'dev' ? 'quick-menus/dev' : 'quick-menus';
